// @flow
import ItemDetails from './ItemDetails';

export default ItemDetails;
